import createLucideIcon from '../createLucideIcon';

const Undo = createLucideIcon('UndoIcon', [
  ['path', { d: 'M3 7v6h6', key: '1v2h90' }],
  ['path', { d: 'M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13', key: '1r6uu6' }],
]);

export default Undo;
